class VariantWizard extends HTMLElement {

    constructor() {
        super();

        this.product = null;

        this.state = {

            option1: "No Cabinet",

            size: "36-inch",

            material: "36\" Solid Oak",

            engraving: "No Engraving",

            height: "Counter Height",

            accessory: "No Accessories"

        };

        this.variant = null;

    }

    connectedCallback() {

        this.product = JSON.parse(
            this.getAttribute('product')
        );

        this.initializeStateFromUrl();

        this.render();

        this.updateVariant();

        this.bindEvents();

        // Main Image
        const mainImage = document.querySelector(
            '.media-wrapper .main-slider .variant--media .product__media img'
        );

        if (mainImage) {
            mainImage.src = this.getAttribute("data-img");
            mainImage.dataset.src = this.getAttribute("data-img");
            mainImage?.closest("picture")?.querySelector("source").setAttribute("srcset",this.getAttribute("data-img"));
        }

        // Thumbnail Image
        const thumbImage = document.querySelector(
            '.media-wrapper .thumb-slider li.variant--media img'
        );

        if (thumbImage) {
            thumbImage.src = this.getAttribute("data-img");
            thumbImage.srcset = this.getAttribute("data-img");
        }

    }

    getMaterials() {

        switch (this.state.size) {

            case '36-inch':
                return [
                    '36\" Solid Oak',
                    '36\" Tempered Glass'
                ];

            case '48-inch':
                return [
                    '48\" Solid Oak',
                    '48\" Solid Oak w/ Glass Insert'
                ];

            default:
                return [];
        }

    }

    getAccessories() {

        switch (this.state.height) {

            case 'Counter Height':
                return [
                    'No Accessories',
                    'Counter-Height Footrail'
                ];

            case 'Bar Height':
                return [
                    'Bar-Height Footrail',
                    'Bar-Height Wooden Risers'
                ];

            default:
                return [];
        }

    }

    render(){

        this.innerHTML = `
            <div class="variant-wizard-header">
                <p class="variant-wizard-heading">${productCustomData.mainHeading}</p>
            </div>
            <div class="variant-wizard-pagination">
                <div class="step-item step-1 active"></div>
                <div class="step-item step-2"></div>
                <div class="step-item step-3"></div>
                <div class="step-item step-4"></div>
                <div class="step-item step-5"></div>
                <div class="step-item step-6"></div>
            </div>
            <div class="variant-wizard__steps">
                ${this.renderCabinetStep()}

                ${this.renderTableSizeStep()}

                ${this.renderMaterialStep()}

                ${this.renderEngravingStep()}

                ${this.renderHeightStep()}

                ${this.renderAccessoryStep()}

            </div>

        `;
    }
    

    renderCabinetStep() {
        

        return `
            <section class="wizard-step active" data-step="1">

                <h3>
                    ${(productCustomData.stepHeading["step-1"])
                        ?
                            productCustomData.stepHeading["step-1"]
                        :
                        "Step 1: Cabinet Feature"
                    }
                </h3>

                <div class="wizard-options">

                    ${this.renderRadioGroup(
                        'option1',
                        [
                            'No Cabinet',
                            'With Cabinet'
                        ],
                        'opt-0'
                    )}
                </div>
                
                <div class="wizard-atc">
                    <button class="wizard-next-button" name="option1">
                        Step 2: Select Table Top Size
                        <span class="cta-arrow">→</span>
                    </button>
                </div>

            </section>
        `;

        // <div class="wizard-help-text">
        //             <div id="video_html_1" style="display: none;">
        //                 ${productCustomData.customHelpText["option-1"]["help-text"]}
                    
        //                 <div class="videos" style="">
        //                     <div class="video_item" data-video="${productCustomData.customHelpText["option-1"]["help-video"]["url"]}">
        //                         <img draggable="false" src="${productCustomData.customHelpText["option-1"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-1"]["help-video"]["alt"]}">
        //                          <p>${productCustomData.customHelpText["option-1"]["help-video"]["alt"]}</p>
        //                          <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                     </div>
        //                 </div>
                    
        //             </div>
        //             <div class="help-box" onclick="openModal('','video_html_1')">
        //                 <span class="question">
                            
        //                     <span class="question-video">
        //                         <img src="${productCustomData.customHelpText["option-1"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-1"]["help-video"]["alt"]}">
        //                         <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                     </span>
                            
        //                     <span class="question-text">
        //                         <span class="question-title">
        //                             ${productCustomData.customHelpText["option-1"]["help-question"]}
        //                             <span>+</span>
        //                         </span>
                                
        //                         <span class="subtext">
        //                             ${productCustomData.customHelpText["option-1"]["help-subtext"]}
        //                         </span>
                                
        //                     </span>
                            
        //                 </span>

        //             </div>
        //         </div>

    }

    renderTableSizeStep() {

        return `
            <section class="wizard-step" data-step="2">

                <h3>
                    ${(productCustomData.stepHeading["step-2"])
                        ?
                            productCustomData.stepHeading["step-2"]
                        :
                        "Step 2: Table Top Size"
                    }
                </h3>

                <div class="wizard-options">

                    ${this.renderRadioGroup(
                        'size',
                        [
                            '36-inch',
                            '48-inch'
                        ],
                        'opt-1'
                    )}
                </div>
                
                <div class="wizard-atc">
                    <button class="wizard-next-button" name="size">
                        Step 3: Select Table Top Material
                        <span class="cta-arrow">→</span>
                    </button>
                    <button class="wizard-prev-button">
                        <span class="cta-arrow">←</span>
                        Previous Step
                    </button>
                </div>

            </section>
        `;

        // <div class="wizard-help-text">
        //             <div id="video_html_2" style="display: none;">
        //                 ${productCustomData.customHelpText["option-2"]["help-text"]}
                    
        //                 <div class="videos" style="">
        //                     <div class="video_item" data-video="${productCustomData.customHelpText["option-2"]["help-video"]["url"]}">
        //                         <img draggable="false" src="${productCustomData.customHelpText["option-2"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-2"]["help-video"]["alt"]}">
        //                          <p>${productCustomData.customHelpText["option-2"]["help-video"]["alt"]}</p>
        //                          <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                     </div>
        //                 </div>
                    
        //             </div>
        //             <div class="help-box" onclick="openModal('','video_html_2')">
        //                 <span class="question">
                            
        //                     <span class="question-video">
        //                         <img src="${productCustomData.customHelpText["option-2"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-2"]["help-video"]["alt"]}">
        //                         <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                     </span>
                            
        //                     <span class="question-text">
        //                         <span class="question-title">
        //                             ${productCustomData.customHelpText["option-2"]["help-question"]}
        //                             <span>+</span>
        //                         </span>
                                
        //                         <span class="subtext">
        //                             ${productCustomData.customHelpText["option-2"]["help-subtext"]}
        //                         </span>
                                
        //                     </span>
                            
        //                 </span>

        //             </div>
        //         </div>

    }

    renderMaterialStep() {

        const materials = this.getMaterials();

        return `
            <section class="wizard-step" data-step="3">

                <h3>
                    ${(productCustomData.stepHeading["step-3"])
                        ?
                            productCustomData.stepHeading["step-3"]
                        :
                        "Step 3: Table Top Material"
                    }
                </h3>

                <div class="wizard-options">
                    ${this.renderRadioGroup(
                        'material',
                        materials,
                        'opt-2'
                    )}
                </div>
                
                <div class="wizard-atc">
                    <button class="wizard-next-button" name="material">
                        Step 4: Select Engraving
                        <span class="cta-arrow">→</span>
                    </button>
                    <button class="wizard-prev-button">
                        <span class="cta-arrow">←</span>
                        Previous Step
                    </button>
                </div>

            </section>
        `;

        // <div class="wizard-help-text">
        //             <div id="video_html_3" style="display: none;">
        //                 ${productCustomData.customHelpText["option-3"]["help-text"]}
                    
        //                 <div class="videos" style="">
        //                     <div class="video_item" data-video="${productCustomData.customHelpText["option-3"]["help-video"]["url"]}">
        //                         <img draggable="false" src="${productCustomData.customHelpText["option-3"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-3"]["help-video"]["alt"]}">
        //                          <p>${productCustomData.customHelpText["option-3"]["help-video"]["alt"]}</p>
        //                          <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                     </div>
        //                 </div>
                    
        //             </div>
        //             <div class="help-box" onclick="openModal('','video_html_3')">
        //                 <span class="question">
                            
        //                     <span class="question-video">
        //                         <img src="${productCustomData.customHelpText["option-3"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-3"]["help-video"]["alt"]}">
        //                         <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                     </span>
                            
        //                     <span class="question-text">
        //                         <span class="question-title">
        //                             ${productCustomData.customHelpText["option-3"]["help-question"]}
        //                             <span>+</span>
        //                         </span>
                                
        //                         <span class="subtext">
        //                             ${productCustomData.customHelpText["option-3"]["help-subtext"]}
        //                         </span>
                                
        //                     </span>
                            
        //                 </span>

        //             </div>
        //         </div>

    }

    renderEngravingStep() {

        return `
            <section class="wizard-step" data-step="4">

                <h3>
                    ${(productCustomData.stepHeading["step-4"])
                        ?
                            productCustomData.stepHeading["step-4"]
                        :
                        "Step 4: Engraving"
                    }
                </h3>

                <div class="wizard-options">
                    ${this.renderRadioGroup(
                        'engraving',
                        [
                            'No Engraving',
                            'With Engraving'
                        ],
                        'opt-3'
                    )}
                </div>
                
                <div class="wizard-atc">
                    <button class="wizard-next-button" name="engraving">
                        Step 5: Select Table Height
                        <span class="cta-arrow">→</span>
                    </button>
                    <button class="wizard-prev-button">
                        <span class="cta-arrow">←</span>
                        Previous Step
                    </button>
                </div>

            </section>
        `;

        // <div class="wizard-help-text">
        //             <div id="video_html_4" style="display: none;">
        //                 ${productCustomData.customHelpText["option-4"]["help-text"]}
                    
        //                 <div class="videos" style="">
        //                     <div class="video_item" data-video="${productCustomData.customHelpText["option-4"]["help-video"]["url"]}">
        //                         <img draggable="false" src="${productCustomData.customHelpText["option-4"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-4"]["help-video"]["alt"]}">
        //                          <p>${productCustomData.customHelpText["option-4"]["help-video"]["alt"]}</p>
        //                          <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                     </div>
        //                 </div>
                    
        //             </div>
        //             <div class="help-box" onclick="openModal('','video_html_4')">
        //                 <span class="question">
                            
        //                     <span class="question-video">
        //                         <img src="${productCustomData.customHelpText["option-4"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-4"]["help-video"]["alt"]}">
        //                         <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                     </span>
                            
        //                     <span class="question-text">
        //                         <span class="question-title">
        //                             ${productCustomData.customHelpText["option-4"]["help-question"]}
        //                             <span>+</span>
        //                         </span>
                                
        //                         <span class="subtext">
        //                             ${productCustomData.customHelpText["option-4"]["help-subtext"]}
        //                         </span>
                                
        //                     </span>
                            
        //                 </span>

        //             </div>
        //         </div>

    }

    renderHeightStep() {

        return `
            <section class="wizard-step" data-step="5">

                <h3>
                    ${(productCustomData.stepHeading["step-5"])
                        ?
                            productCustomData.stepHeading["step-5"]
                        :
                        "Step 5: Table Height"
                    }
                </h3>

                <div class="wizard-options">
                    ${this.renderRadioGroup(
                        'height',
                        [
                            'Counter Height',
                            'Bar Height'
                        ],
                        'opt-4'
                    )}
                </div>
                
                
                <div class="wizard-atc">
                    <button class="wizard-next-button" name="height">
                        Step 6: Select Accessories
                        <span class="cta-arrow">→</span>
                    </button>
                    <button class="wizard-prev-button">
                        <span class="cta-arrow">←</span>
                        Previous Step
                    </button>
                </div>

            </section>
        `;

        // ${(productCustomData.customHelpText["option-5"]["help-question"] != '' && productCustomData.customHelpText["option-5"]["help-video"]["url"] != '')
        //             ?
        //             `<div class="wizard-help-text">
        //                 <div id="video_html_4" style="display: none;">
        //                     ${productCustomData.customHelpText["option-5"]["help-text"]}
                        
        //                     <div class="videos" style="">
        //                         <div class="video_item" data-video="${productCustomData.customHelpText["option-5"]["help-video"]["url"]}">
        //                             <img draggable="false" src="${productCustomData.customHelpText["option-5"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-5"]["help-video"]["alt"]}">
        //                             <p>${productCustomData.customHelpText["option-5"]["help-video"]["alt"]}</p>
        //                             <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                         </div>
        //                     </div>
                        
        //                 </div>
        //                 <div class="help-box" onclick="openModal('','video_html_4')">
        //                     <span class="question">
                                
        //                         <span class="question-video">
        //                             <img src="${productCustomData.customHelpText["option-5"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-5"]["help-video"]["alt"]}">
        //                             <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                         </span>
                                
        //                         <span class="question-text">
        //                             <span class="question-title">
        //                                 ${productCustomData.customHelpText["option-5"]["help-question"]}
        //                                 <span>+</span>
        //                             </span>
                                    
        //                             <span class="subtext">
        //                                 ${productCustomData.customHelpText["option-5"]["help-subtext"]}
        //                             </span>
                                    
        //                         </span>
                                
        //                     </span>

        //                 </div>
        //             </div>`
        //             :
        //             ""
        //         }

    }

    renderAccessoryStep() {

        const accessories = this.getAccessories();

        return `
            <section class="wizard-step" data-step="6">

                <h3>
                    ${(productCustomData.stepHeading["step-6"])
                        ?
                            productCustomData.stepHeading["step-6"]
                        :
                        "Step 6: Accessoriest"
                    }
                </h3>

                <div class="wizard-options">
                    ${this.renderRadioGroup(
                        'accessory',
                        accessories,
                        'opt-5'
                    )}
                </div>
                
                
                <div class="wizard-atc">
                    <button class="wizard-prev-button">
                        <span class="cta-arrow">←</span>
                        Previous Step
                    </button>
                </div>

            </section>
        `;

        // ${(productCustomData.customHelpText["option-6"]["help-question"] != '' && productCustomData.customHelpText["option-6"]["help-video"]["url"] != '')
        //             ?
        //             `<div class="wizard-help-text">
        //                 <div id="video_html_4" style="display: none;">
        //                     ${productCustomData.customHelpText["option-6"]["help-text"]}
                        
        //                     <div class="videos" style="">
        //                         <div class="video_item" data-video="${productCustomData.customHelpText["option-6"]["help-video"]["url"]}">
        //                             <img draggable="false" src="${productCustomData.customHelpText["option-6"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-6"]["help-video"]["alt"]}">
        //                             <p>${productCustomData.customHelpText["option-6"]["help-video"]["alt"]}</p>
        //                             <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                         </div>
        //                     </div>
                        
        //                 </div>
        //                 <div class="help-box" onclick="openModal('','video_html_4')">
        //                     <span class="question">
                                
        //                         <span class="question-video">
        //                             <img src="${productCustomData.customHelpText["option-6"]["help-video"]["preview"]}" alt="Play Video for ${productCustomData.customHelpText["option-6"]["help-video"]["alt"]}">
        //                             <svg class="play_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;"><path d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM6 11.3333V4.66667L11.3333 8L6 11.3333Z" fill="#F5F5F5"></path></svg>
        //                         </span>
                                
        //                         <span class="question-text">
        //                             <span class="question-title">
        //                                 ${productCustomData.customHelpText["option-6"]["help-question"]}
        //                                 <span>+</span>
        //                             </span>
                                    
        //                             <span class="subtext">
        //                                 ${productCustomData.customHelpText["option-6"]["help-subtext"]}
        //                             </span>
                                    
        //                         </span>
                                
        //                     </span>

        //                 </div>
        //             </div>`
        //             :
        //             ""
        //         }

    }



    renderRadioGroup(name, values = [],opt) {

        const alterLabel = {
            "36-inch": "36\" Diameter",
            "48-inch": "48\" Diameter",
            "Counter Height": "Counter-Height (36\" tall table)",
            "Bar Height": "Bar-Height (42\" tall table)"
        };

        return values.map((value,index) => {

            const checked =
                this.state[name] === value
                    ? 'checked'
                    : '';

            return `
                <input
                    type="radio"
                    id="${name}-opt-${index}"
                    name="${name}"
                    value='${value}'
                    ${(checked)?checked:(index == 0)?'checked':''}
                >
                <label class="wizard-option" for="${name}-opt-${index}">   

                    ${(productCustomData.optionCustomImages[value])
                        ? `<div class="wizard-image">
                                <img src="${ productCustomData.optionCustomImages[value]}" width="100" height="71">
                            </div>`
                        :
                        ""
                    }
                    <span>${
                        (alterLabel[value])
                        ?alterLabel[value]
                        :value
                    }</span>
                    ${(productCustomData.customSubtitle[value])?
                        `<p class="wizard-subtitle">
                            ${(productCustomData.customSubtitle[value])
                                ? productCustomData.customSubtitle[value]
                                : ""
                            }
                        </p>`
                        :
                        ""
                    }
                    ${(productCustomData.customPrice[value])?
                        `<p class="wizard-price">
                            ${(productCustomData.customPrice[value])
                                ? productCustomData.customPrice[value]
                                : ""
                            }
                        </p>`
                        :
                        ""
                    }

                </label>
            `;

        }).join('');

    }

    bindEvents() {

        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('click',this.onClick.bind(this));

    }

    onChange(event) {

        const target = event.target;

        if (!target.matches('input[type="radio"]')) {
            return;
        }


        const { name, value } = target;

        this.state[name] = value;

        switch (name) {

            case 'size':

                // Reset dependent selections
                this.state.material = null;

                this.renderMaterialOptions();

                break;

            case 'height':

                this.state.accessory = null;

                this.renderAccessoryOptions();

                break;

        }

        this.updateVariant();

    }

    onClick(event){
        const target = event.target;

       // console.log(target.matches('button.wizard-next-button'));

        if (target.matches('button.wizard-next-button')) {
            let step = target.closest(".wizard-step").getAttribute("data-step");
            let nextStep = parseInt(step) + 1;

            target.closest(".wizard-step").classList.remove("active");
            document.querySelector(".variant-wizard-pagination .step-"+step).classList.remove("active");
            document.querySelector(".variant-wizard-pagination .step-"+step).classList.add("complete");

            document.querySelector(".wizard-step[data-step='"+nextStep+"']").classList.add("active");
            document.querySelector(".variant-wizard-pagination .step-"+nextStep).classList.add("active");

            if(nextStep == 6)
            {
                document.querySelector(".variant-wizard-pagination .step-"+nextStep).classList.add("complete");
                document.querySelector('.buy_buttons_with_tabs').style.display = 'block';
            }

            return;
        }

        if(target.matches('button.wizard-prev-button')){
            let step = target.closest(".wizard-step").getAttribute("data-step");
            let prevStep = parseInt(step) - 1;

            target.closest(".wizard-step").classList.remove("active");
            document.querySelector(".variant-wizard-pagination .step-"+step).classList.remove("active");
            document.querySelector(".variant-wizard-pagination .step-"+step).classList.remove("complete");

            document.querySelector(".wizard-step[data-step='"+prevStep+"']").classList.add("active");
            document.querySelector(".variant-wizard-pagination .step-"+prevStep).classList.add("active");

            document.querySelector('.buy_buttons_with_tabs').style.display = 'none';

            return;
        }

        return;

    }

    renderMaterialOptions() {

        const container = this.querySelector(
            '[data-step="3"] .wizard-options'
        );

        if (!container) {
            return;
        }

        container.innerHTML = this.renderRadioGroup(
            'material',
            this.getMaterials(),
            'opt-2'
        );

        this.state["material"] = container.querySelector("input:checked").value;

        this.updateVariant();

    }

    renderAccessoryOptions() {

        const container = this.querySelector(
            '[data-step="6"] .wizard-options'
        );

        if (!container) {
            return;
        }

        container.innerHTML = this.renderRadioGroup(
            'accessory',
            this.getAccessories(),
            'opt-5'
        );

        this.state["accessory"] = container.querySelector("input:checked").value;

        this.updateVariant();

    }

    updateVariant() {

        if (!this.isComplete()) {
            return;
        }

        const options = this.buildVariantOptions();

        const variant = this.findVariant(options);

        if (!variant) {
            return;
        }

        this.variant = variant;

        this.selectVariant();

    }

    isComplete() {

        return Object.values(this.state).every(value => value !== null);

    }

    buildVariantOptions() {

        const option2Map = {
            '36-inch': {
                '36\" Solid Oak': '36" Solid Oak',
                '36\" Tempered Glass': '36" Tempered Glass'
            },
            '48-inch': {
                '48\" Solid Oak': '48" Solid Oak',
                '48\" Solid Oak w/ Glass Insert': '48" Solid Oak w/ Glass Insert'
            }
        };

        const option3Map = {
            'No Engraving': {
                'No Accessories': 'No Engraving / No Accessories',
                'Counter-Height Footrail': 'No Engraving / Counter-Height Footrail',
                'Bar-Height Footrail': 'No Engraving / Bar-Height Footrail',
                'Bar-Height Wooden Risers': 'No Engraving / Bar-Height Wooden Riser'
            },
            'With Engraving': {
                'No Accessories': 'With Engraving / No Accessories',
                'Counter-Height Footrail': 'With Engraving / Counter-Height Footrail',
                'Bar-Height Footrail': 'With Engraving / Bar-Height Footrail',
                'Bar-Height Wooden Risers': 'With Engraving / Bar-Height Wooden Riser'
            }
        };

       // console.log(this.state);

        return {
            option1: this.state.option1,
            option2: option2Map[this.state.size][this.state.material],
            option3: option3Map[this.state.engraving][this.state.accessory]
        };

    }

    findVariant(options) {

        return this.product.variants.find((variant) => {

            return (
                variant.option1 === options.option1 &&
                variant.option2 === options.option2 &&
                variant.option3 === options.option3
            );

        }) || null;

    }

    selectVariant() {

        if (!this.variant) {
            return;
        }

        this.updateUrl();

        this.updateVariantInput();

        this.emitVariantChange();

        this.updateMedia();

        this.updatePrice();

    }

    updateVariantInput() {

        const inputs = document.querySelectorAll(
            'form[action*="/cart/add"] input[name="id"]'
        );

        if (!inputs) {
            return;
        }

        inputs.forEach(input => {
            input.value = this.variant.id;

            input.dispatchEvent(
                new Event('change', {
                    bubbles: true
                })
            );
        });
        

    }

    updateUrl() {

        const url = new URL(window.location);

        url.searchParams.set(
            'variant',
            this.variant.id
        );

        window.history.replaceState(
            {},
            '',
            url
        );

    }

    emitVariantChange() {

        this.dispatchEvent(
            new CustomEvent('variant:change', {
                bubbles: true,
                detail: {
                    variant: this.variant
                }
            })
        );

    }

    updateMedia() {
        if (!this.variant) return;

        if (!this.variant.featured_image) return;

        // Main Image
        const mainImage = document.querySelector(
            '.media-wrapper .main-slider .variant--media .product__media img'
        );

        if (mainImage) {
            mainImage.src = this.variant.featured_image.src;
            mainImage.dataset.src = this.variant.featured_image.src;
            mainImage?.closest("picture")?.querySelector("source").setAttribute("srcset",this.variant.featured_image.src);
        }

        // Thumbnail Image
        const thumbImage = document.querySelector(
            '.media-wrapper .thumb-slider li.variant--media img'
        );

        if (thumbImage) {
            thumbImage.src = this.variant.featured_image.src;
            thumbImage.srcset = this.variant.featured_image.src;
        }

        setTimeout(function () {
            document.querySelector(".thumbnail-list1 li:first-child").click();
        }, 100);

    }

    updatePrice(){
        if (!this.variant) return;

        const requestedVariantId = this.variant.id;
        const sectionId = this.dataset.section;

        fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
        }`
        )
        .then((response) => response.text())
        .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.variant.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const destination = document.getElementById(`price-${this.dataset.section}`);
            const source = html.getElementById(
            `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
            );
            const skuSource = html.getElementById(
            `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
            );
            const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
            const inventorySource = html.getElementById(
            `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
            );
            const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
            }

            const price = document.getElementById(`price-${this.dataset.section}`);

            if (price) price.classList.remove('visibility-hidden');

            if (inventoryDestination)
            inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

            const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
            this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut
            );

            // publish(PUB_SUB_EVENTS.variantChange, {
            // data: {
            //     sectionId,
            //     html,
            //     variant: this.variant,
            // },
            // });

            document.querySelector(".custom-atc-price-item").innerHTML = " | " +document.querySelector(".custom-price-item").innerHTML;
            document.querySelector(".custom-price").innerHTML = document.querySelector(".custom-price-item").innerHTML;

        });


    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
        } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    initializeStateFromUrl() {

        const params = new URLSearchParams(
            window.location.search
        );

        const variantId = Number(
            params.get('variant')
        );

        if (!variantId || !this.product?.variants?.length) {
            return;
        }

        const variant = this.product.variants.find(
            variant => Number(variant.id) === variantId
        );

        if (!variant) {
            return;
        }

        this.variant = variant;

        this.state.option1 = variant.option1;

        this.state = this.getStateFromVariant(variant);

    }

    getStateFromVariant(variant) {

        const state = {
            option1: variant.option1,
            size: null,
            material: null,
            engraving: null,
            height: null,
            accessory: null
        };

        /*
        * OPTION 2
        *
        * 36" Solid Oak
        * 36" Tempered Glass
        * 48" Solid Oak
        * 48" Solid Oak w/ Glass Insert
        */

        switch (variant.option2) {

            case '36" Solid Oak':

                state.size = '36-inch';
                state.material = '36" Solid Oak';

                break;

            case '36" Tempered Glass':

                state.size = '36-inch';
                state.material = '36" Tempered Glass';

                break;

            case '48" Solid Oak':

                state.size = '48-inch';
                state.material = '48" Solid Oak';

                break;

            case '48" Solid Oak w/ Glass Insert':

                state.size = '48-inch';
                state.material = '48" Solid Oak w/ Glass Insert';

                break;

        }


        /*
        * OPTION 3
        *
        * No Engraving / No Accessories
        * With Engraving / No Accessories
        * No Engraving / Counter-Height Footrail
        * etc.
        */

        const option3 = variant.option3;

        if (!option3) {
            return state;
        }

        if (option3.startsWith('No Engraving')) {

            state.engraving = 'No Engraving';

        }

        if (option3.startsWith('With Engraving')) {

            state.engraving = 'With Engraving';

        }


        if (option3.includes('Counter-Height Footrail')) {

            state.height = 'Counter Height';

            state.accessory = 'Counter-Height Footrail';

        }
        else if (option3.includes('Bar-Height Footrail')) {

            state.height = 'Bar Height';

            state.accessory = 'Bar-Height Footrail';

        }
        else if (option3.includes('Bar-Height Wooden Risers')) {

            state.height = 'Bar Height';

            state.accessory = 'Bar-Height Wooden Risers';

        }
        else if (option3.includes('No Accessories')) {

            state.height = 'Counter Height';

            state.accessory = 'No Accessories';
           

        }

        /*
        * If there are no accessories, the height
        * cannot be determined from Option 3.
        *
        * We therefore leave it null.
        */

        return state;

    }
    

}

customElements.define('variant-wizard', VariantWizard);


function openModal(msg, video = '') {
    document.getElementById('modal-content').innerHTML = msg + document.getElementById(video).innerHTML;
    document.getElementById('modal').style.display = 'flex';

    var modal_video = document.getElementById('modal_video1');
    var video = document.querySelector('#modal_video1 video');
    var source = document.querySelector('#modal_video1 video source');

    document.querySelectorAll('#modal-content .video_item').forEach((el) => {
        el.addEventListener('click', function () {
            var src = el.dataset.video;


            video.pause()
            source.setAttribute('src', src);
            video.load();
            video.play();

            modal_video.showModal();
        })
    })
}

function closeModal() {
    document.getElementById('modal').style.display = 'none';
}

document.querySelector('#modal_video1 button').addEventListener('click', function (event) {
    let video = document.querySelector('#modal_video1 video');
    video.pause();
});